import { ToolbarButton, Tooltip } from "@fluentui/react-components";
import { FilterRegular, FilterDismissRegular } from "@fluentui/react-icons";
import { TFunction } from "i18next";
import React from "react";

type Props = {
  className?: string;
  isActive: boolean;
  onClick?: () => void;
  text?: string;
  t: TFunction;
  /** In-app guide anchor, forwarded to the button. */
  "data-help"?: string;
};

export const ColumnOptionsButton = ({
  className,
  isActive,
  onClick,
  text,
  t,
  "data-help": dataHelp,
}: Props) => {
  return (
    <Tooltip content={text ?? t("greco.columnOptions")} relationship="label">
      <ToolbarButton
        appearance="subtle"
        data-help={dataHelp}
        className={className}
        onClick={onClick}
        icon={isActive ? <FilterDismissRegular /> : <FilterRegular />}
      >
        {text ?? t("greco.columnOptions")}
      </ToolbarButton>
    </Tooltip>
  );
};
